<script setup lang="ts">
interface Props {
  text?: string
  search: string
}

const props = defineProps<Props>()

const textHighlight = computed(() => {
  const { text, search } = props
  if (!search || !text)
    return text
  const match = new RegExp(search, 'gi')

  return text.replace(match, str => `<span class="bg-purple/30 font-semibold">${str}</span>`)
})
</script>

<template>
  <p v-html="textHighlight" />
</template>
